import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/Products',
          name: 'products',
          component: resolve => require(['@/view/Products'], resolve),
          meta: {
            title: '产品中心'
          },
          children: [
            {
              path: '/products',
              redirect: '/products/sfa'
            },
            {
              path: '/products/sfa',
              name: 'products',
              component: resolve => require(['@/view/Products/Sfa'], resolve),
              meta: {
                title: '产品中心丨SFA'
              }
            },
            {
              path: '/products/sps',
              name: 'products',
              component: resolve => require(['@/view/Products/Sps'], resolve),
              meta: {
                title: '产品中心丨SPS'
              }
            },
            {
              path: '/products/tpm',
              name: 'products',
              component: resolve => require(['@/view/Products/Tpm'], resolve),
              meta: {
                title: '产品中心丨TPM'
              }
            },
            {
              path: '/products/dms',
              name: 'products',
              component: resolve => require(['@/view/Products/Dms'], resolve),
              meta: {
                title: '产品中心丨DMS'
              }
            },
            {
              path: '/products/crm',
              name: 'products',
              component: resolve => require(['@/view/Products/B-Crm'], resolve),
              meta: {
                title: '产品中心丨b-CRM'
              }
            },
            {
              path: '/products/ywym',
              name: 'products',
              component: resolve => require(['@/view/Products/Ywym'], resolve),
              meta: {
                title: '产品中心丨一物一码'
              }
            },
            {
              path: '/products/ai',
              name: 'products',
              component: resolve => require(['@/view/Products/Ai'], resolve),
              meta: {
                title: '产品中心丨AI应用'
              }
            },
          ]
        }, {
          path: '/customer',
          name: 'customer',
          component: resolve => require(['@/view/Customer'], resolve),
          meta: {
            title: '客户案例'
          },
          children: [
            {
              path: '/customer',
              redirect: '/customer/qdpj'
            },
            {
              path: '/customer/qdpj',
              name: 'customer',
              component: resolve => require(['@/view/Customer/Qdpj'], resolve),
              meta: {
                title: '客户案例丨青岛啤酒'
              }
            },
            {
              path: '/customer/mnry',
              name: 'customer',
              component: resolve => require(['@/view/Customer/Mnry'], resolve),
              meta: {
                title: '客户案例丨蒙牛乳业'
              }
            },
            {
              path: '/customer/fjjt',
              name: 'customer',
              component: resolve => require(['@/view/Customer/Fjjt'], resolve),
              meta: {
                title: '客户案例丨汾酒集团'
              }
            },
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js